import { NgClass } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { AppMenuComponent } from '../app-menu/app-menu.component';
import { AppProfileSidebarComponent } from '../app-profile-sidebar/app-profile-sidebar.component';
import { AppTopbarComponent } from '../app-topbar/app-topbar.component';
import { ImpersonationBannerComponent } from '../impersonation-banner/impersonation-banner.component';
import { LayoutService } from '../layout.service';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [
    NgClass,
    RouterLink,
    RouterOutlet,
    AppMenuComponent,
    AppTopbarComponent,
    AppProfileSidebarComponent,
    ImpersonationBannerComponent,
    TranslatePipe,
  ],
  template: `
    <div class="layout-container" [ngClass]="layoutService.containerClass()">
      <aside
        class="layout-sidebar"
        (mouseenter)="layoutService.onSidebarMouseEnter()"
        (mouseleave)="layoutService.onSidebarMouseLeave()"
      >
        <div class="sidebar-header">
          <a routerLink="/dashboard" class="app-logo">
            <img
              src="assets/img/dreampay-logo.svg"
              alt="DreamPay"
              class="app-logo-normal"
              style="height: 24px; width: auto"
            />
            <img
              src="assets/img/dreampay-icon.svg"
              alt="DreamPay"
              class="app-logo-small"
              style="height: 28px; width: auto"
            />
          </a>
          <button
            class="layout-sidebar-anchor p-link"
            type="button"
            (click)="layoutService.toggleAnchor()"
            [attr.aria-label]="
              (layoutService.anchored()
                ? 'layout.sidebar.unpinSidebar'
                : 'layout.sidebar.pinSidebar'
              ) | translate
            "
          ></button>
        </div>
        <div class="layout-menu-container">
          <app-menu />
        </div>
      </aside>
      <div class="layout-content-wrapper">
        <div app-topbar></div>
        <app-impersonation-banner />
        <div class="layout-content">
          <router-outlet />
        </div>
      </div>
      @defer (when layoutService.profileSidebarVisible()) {
        <app-profile-sidebar />
      }
      @if (layoutService.mobileMenuActive()) {
        <div
          class="layout-mask"
          role="button"
          tabindex="0"
          [attr.aria-label]="'layout.sidebar.closeMenu' | translate"
          (click)="layoutService.closeMobileMenu()"
          (keydown.enter)="layoutService.closeMobileMenu()"
          (keydown.escape)="layoutService.closeMobileMenu()"
        ></div>
      }
    </div>
  `,
})
export class AppLayoutComponent {
  readonly layoutService = inject(LayoutService);
}
